import { render, staticRenderFns } from "./blockSize.vue?vue&type=template&id=681cac2e&scoped=true&"
import script from "./blockSize.vue?vue&type=script&lang=js&"
export * from "./blockSize.vue?vue&type=script&lang=js&"
import style0 from "./blockSize.vue?vue&type=style&index=0&id=681cac2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681cac2e",
  null
  
)

export default component.exports